/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.agent-header-banner-label': "Bannière d'agent",
  'ai-mate.agent-list.all-agents-section-title': 'Tous les agents',
  'ai-mate.agent-list.beta-lozenge-title': 'Bêta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Vous avez remplacé le propriétaire de {agentName} par {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Propriétaire modifié',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Voulez-vous vraiment supprimer cet agent ? Cette action est irréversible.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Supprimer « {agentName} » ?',
  'ai-mate.agent-list.delete-agent-error': "Impossible de supprimer l'agent",
  'ai-mate.agent-list.delete-agent-error-flag-description':
    "Une erreur s'est produite lors de la suppression de l'agent. Réessayez dans quelques instants.",
  'ai-mate.agent-list.delete-agent-error-flag-title': "Impossible de supprimer l'agent",
  'ai-mate.agent-list.delete-agent-error.agent-in-use': "L'agent est en cours d'utilisation. Réessayez ultérieurement.",
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Cet agent est introuvable.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    "Vous ne pouvez pas supprimer des agents que vous n'avez pas vous-même créés. Veuillez contacter le propriétaire de l'agent.",
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Vous avez supprimé {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent supprimé',
  'ai-mate.agent-list.development-section-title': 'Agents de développement',
  'ai-mate.agent-list.load-more-button-loading': "Chargement d'autres agents...",
  'ai-mate.agent-list.load-more-button-ready': 'Charger plus',
  'ai-mate.agent-list.loading-agents': 'Chargement des agents...',
  'ai-mate.agent-list.no-results': 'Aucun résultat pour « {searchValue} »',
  'ai-mate.agent-list.recommended-agents-section-title': 'Recommandés',
  'ai-mate.agent-list.searching-agents': "Recherche d'agents...",
  'ai-mate.agent-list.templates-description':
    "Utilisez ces modèles pour créer votre propre agent développeur. Choisissez le modèle d'agent adapté à votre travail, sélectionnez Utiliser le modèle, puis remplissez l'invite du modèle avec des informations telles que le dépôt, le dossier, la langue et la bibliothèque. Créez des agents de développement sur mesure pour coder différents projets, tâches ou dépôts.",
  'ai-mate.agent-list.templates-lozenge-title': 'Modèle',
  'ai-mate.agent-list.templates-title': 'Modèles de codage',
  'ai-mate.agent-message.agent-not-found': 'Agent introuvable',
  'ai-mate.agent-message.convo-title': "Chat avec {agentName} déclenché à partir de l'intégration de lien intelligent",
  'ai-mate.agent-message.copy-link': "Copier le lien vers l'agent",
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Saisissez un message pour {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Enregistrer',
  'ai-mate.agent-message.view-profile': 'Afficher le profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annuler',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Supprimer',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Discuter avec {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL copiée',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Copier le lien',
  'ai-mate.agent-profile-info.hidden-icon': 'Masqué',
  'ai-mate.agent-profile-info.hidden-tooltip': "L'agent n'apparaîtra pas dans les résultats de la recherche",
  'ai-mate.agent-profile-info.star-agent-tooltip': "Ajouter l'agent aux favoris",
  'ai-mate.agent-selector.agent-not-found': 'Agent introuvable',
  'ai-mate.agent-selector.default-agent-description':
    'Obtenez des réponses, générez de nouvelles idées et accélérez le travail quotidien.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Fermer la vue des agents',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': 'Par défaut',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': 'Inactif',
  'ai-mate.profile-card-preview.actions-title': 'Actions',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Description',
  'ai-mate.profile-card-preview.agent-title-label': 'Titre',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Prompts pour engager la conversation',
  'ai-mate.profile-card-preview.empty-actions': 'Aucune',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Aucun',
  'ai-mate.profile-card-preview.empty-instructions': 'Aucun',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Aucun sélectionné',
  'ai-mate.profile-card-preview.instructions-title': 'Instructions',
  'ai-mate.profile-card-preview.knowledge-title': 'Connaissances',
  'ai-mate.profile-card-preview.regenerate-label': 'Régénérer {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copie',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label':
    'Faites glisser pour réorganiser',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error':
    "Impossible d'enregistrer les changements",
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Une erreur inconnue est survenue. Veuillez réessayer',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Un agent portant ce nom existe déjà',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Supprimer',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Générer des prompts pour engager la conversation',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} ne peut pas dépasser {maxLength,number} caractère} other {{fieldName} ne peut pas dépasser {maxLength,number} caractères}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Suivant',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Redémarrer',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Passer à la configuration manuelle',
  'create-agent.owner-field.confirm-modal-cancel': 'Annuler',
  'create-agent.owner-field.confirm-modal-confirm': 'Oui, continuer',
  'create-agent.owner-field.confirm-modal-content':
    'Vous êtes sur le point de remplacer le propriétaire de cet agent par {name}. Ce faisant, vous ne pourrez plus modifier ni gérer cet agent.',
  'create-agent.owner-field.confirm-modal-title': "Vous êtes sur le point de perdre l'accès en modification",
  'create-agent.owner-field.owner-description': "Il s'agit de la personne qui peut modifier ou gérer l'agent.",
  'create-agent.owner-field.owner-label': 'Propriétaire',
  'rovo-chat.agent-card.deactivated-name': '{name} (désactivé)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Trop de demandes. Patientez un instant.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Réessayer',
  'rovo-chat.browse-agents.all-agents-button': 'Tous',
  'rovo-chat.browse-agents.close-button': 'Fermer',
  'rovo-chat.browse-agents.create-agent-button': 'Créer',
  'rovo-chat.browse-agents.create-an-agent-button': 'Créer un agent',
  'rovo-chat.browse-agents.create-button-disabled-tooltip':
    "Vous n'êtes pas autorisé(e) à créer des agents sur ce site",
  'rovo-chat.browse-agents.created-by-label': '<text>par</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agents de codage',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoris',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent ajouté aux favoris',
  'rovo-chat.browse-agents.modal-title': 'Parcourir les agents',
  'rovo-chat.browse-agents.my-agents-button': 'Mes agents',
  'rovo-chat.browse-agents.no-created-agents':
    "Il semblerait que vous n'ayez encore créé d'agent. Commencez par dupliquer d'autres agents existants ou créez-en un à partir de zéro.",
  'rovo-chat.browse-agents.no-created-agents-header': "Aucun agent créé pour l'instant",
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': "Vous n'avez créé aucun agent",
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    "Vous avez besoin de l'autorisation d'un administrateur pour créer des agents Rovo sur ce site.",
  'rovo-chat.browse-agents.no-starred-agents':
    'Si vous avez un agent préféré ou si vous utilisez souvent un agent, ajoutez-le à vos favoris pour y accéder plus facilement.',
  'rovo-chat.browse-agents.no-starred-agents-header': "Vous n'avez pas encore ajouté d'agent à vos favoris",
  'rovo-chat.browse-agents.search-input.placeholder': 'Rechercher des agents',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Rechercher des modèles',
  'rovo-chat.browse-agents.see-all-agents-button': 'Voir tous les agents',
  'rovo-chat.browse-agents.templates-button': 'Modèles',
  'rovo-chat.create-agent.actions-section-description':
    "Ajoutez des actions pour permettre à votre agent d'effectuer des tâches dans Jira, Confluence et Jira Service Management. <link>Les actions d'agent, qu'est-ce que c'est ?</link>",
  'rovo-chat.create-agent.add-actions-button-label': 'Ajouter des actions',
  'rovo-chat.create-agent.all-content-label': 'Tout le contenu',
  'rovo-chat.create-agent.back-button': 'Retour',
  'rovo-chat.create-agent.beta-lozenge': 'Bêta',
  'rovo-chat.create-agent.confirm-leave-modal.body':
    "Vous n'avez pas encore créé votre agent, souhaitez-vous le supprimer ?",
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Annuler',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': "Oui, supprimer l'agent",
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Agent non terminé',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Voulez-vous vraiment ignorer tous les changements apportés à cet agent ?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Confirmer',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Relancer la création de votre agent',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    "Toute personne peut s'en servir pour démarrer une conversation avec votre agent. Si rien ne vous vient à l'esprit, nous pouvons les générer pour vous.",
  'rovo-chat.create-agent.conversation-starters-field-label': 'Prompts pour engager la conversation',
  'rovo-chat.create-agent.create-agent-button': 'Créer',
  'rovo-chat.create-agent.ctions-section-title': 'Actions',
  'rovo-chat.create-agent.description-field-description':
    "Toute personne peut consulter la description sur le profil de l'agent pour en savoir plus à son sujet.",
  'rovo-chat.create-agent.description-field-label': 'Description',
  'rovo-chat.create-agent.description-field-placeholder':
    'Rédigez une brève description de votre agent (par exemple, rédacteur créatif pour les billets de blog marketing)',
  'rovo-chat.create-agent.instructions-field-description':
    "Comment voulez-vous que cet agent se comporte ? Que peut-il faire ? <link>En savoir plus sur la rédaction d'instructions pour un agent</link>",
  'rovo-chat.create-agent.instructions-field-label': 'Instructions',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Personnalisez les instructions pour cet agent',
  'rovo-chat.create-agent.intro-description-part-1':
    'Créez un agent avec des connaissances spécialisées pour répondre aux questions, rédiger et vérifier du contenu, et effectuer des tâches afin de vous aider à faire avancer le travail.',
  'rovo-chat.create-agent.intro-description-part-2':
    "Si vous n'avez pas besoin d'aide, vous pouvez <bold>passer à la configuration manuelle</bold>.",
  'rovo-chat.create-agent.intro-description-part-3': 'Sinon, restez avec moi. Nous pouvons en créer un ensemble.',
  'rovo-chat.create-agent.intro-step-1-content':
    "Je vais créer des instructions pour l'agent en fonction de ce que vous écrivez. Dites-moi simplement pour quelles tâches vous prévoyez d'utiliser l'agent.",
  'rovo-chat.create-agent.intro-step-1-title': 'Décrivez ce que vous souhaitez que votre agent fasse',
  'rovo-chat.create-agent.intro-step-2-content':
    'Réfléchissons ensemble pour déterminer le nom et la personnalité de votre agent. Dites-moi si votre agent est empathique, direct ou drôle.',
  'rovo-chat.create-agent.intro-step-2-title': 'Façonnez sa personnalité',
  'rovo-chat.create-agent.intro-step-3-content':
    'Sélectionnez <bold>Suivant</bold> pour vérifier votre nouvel agent, ajouter des actions, des connaissances et une photo de profil. Lorsque vous avez terminé, sélectionnez <bold>Créer</bold>.',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Appuyez sur <bold>Suivant</bold> pour vérifier votre nouvel agent, ajouter des compétences, des connaissances et une photo de profil. Lorsque vous avez terminé, sélectionnez <bold>Créer</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Vérifiez les informations et créez votre agent',
  'rovo-chat.create-agent.intro-title': '👋 Créons votre agent',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Tous les projets',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Tous les espaces',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': 'Rechercher une base de connaissances',
  'rovo-chat.create-agent.knowledge-field-description':
    "Spécifiez les connaissances de l'agent en l'autorisant uniquement à faire référence aux sources que vous fournissez",
  'rovo-chat.create-agent.knowledge-field-label': 'Connaissances',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Uniquement faire référence à ces sources',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Liens',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Suggérés',
  'rovo-chat.create-agent.manage-actions-button-label': 'Gérer les actions',
  'rovo-chat.create-agent.name-field-description': "Les gens peuvent utiliser ceci pour rechercher l'agent.",
  'rovo-chat.create-agent.name-field-label': 'Nom',
  'rovo-chat.create-agent.name-field-placeholder': 'Donnez un nom à votre agent',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Une erreur inattendue est survenue. Veuillez réessayer.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Bonjour, je suis là pour vous aider à créer un agent personnalisé. Dites-moi ce que vous aimeriez que votre agent fasse.',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Créer un agent',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Saisissez votre message',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Envoyer',
  'rovo-chat.create-agent.page-title': 'Créer un agent',
  'rovo-chat.create-agent.page-title-edit': "Modifier l'agent",
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Rechercher des pages',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Rechercher des espaces',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Toutes',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Bêta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Annuler',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Fermer',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Il est recommandé de sélectionner moins de {count,number} action pour des performances optimales} other {Il est recommandé de sélectionner moins de {count,number} actions pour des performances optimales}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Enregistrer',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Rechercher des actions',
  'rovo-chat.create-agent.select-action-modal-title': 'Ajouter des actions',
  'rovo-chat.create-agent.select-content-under-label': 'Sélectionner le contenu sous',
  'rovo-chat.create-agent.select-spaces-label': 'Sélectionnez des espaces',
  'rovo-chat.create-agent.selected-actions-label': 'Actions sélectionnées :',
  'rovo-chat.create-agent.unknown-owner': 'Inconnu',
  'rovo-chat.create-agent.update-agent-button': 'Mettre à jour',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Si vous continuez, vous perdrez les changements non enregistrés. Sélectionnez Annuler pour continuer à modifier cet agent.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continuer, ignorer les changements',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Abandonner les changements',
  'rovo-chat.view-agent.about-label': 'À propos',
  'rovo-chat.view-agent.actions-label': 'Actions',
  'rovo-chat.view-agent.agent-instructions.copy-label': 'Copier',
  'rovo-chat.view-agent.agent-instructions.copy-tooltip': 'Copier les instructions',
  'rovo-chat.view-agent.agent-instructions.placeholder': "Cet agent n'a pas d'instructions personnalisées",
  'rovo-chat.view-agent.all-knowledge-added': 'Toutes les connaissances organisationnelles',
  'rovo-chat.view-agent.behaviour-label': 'Comportement',
  'rovo-chat.view-agent.beta-label': 'Bêta',
  'rovo-chat.view-agent.beta-tag': 'Bêta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat avec un agent',
  'rovo-chat.view-agent.close-button': 'Fermer',
  'rovo-chat.view-agent.copied-instructions-tooltip-label': 'Copié',
  'rovo-chat.view-agent.copy-instructions-tooltip-label': 'Copier',
  'rovo-chat.view-agent.created-by-label': '<text>par</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Nombre de favoris',
  'rovo-chat.view-agent.go-back-label': 'Retour',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Les instructions des agents Forge générés avec le code sont masquées pour des questions de confidentialité.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Ces instructions sont privées',
  'rovo-chat.view-agent.hidden-knowledge-description':
    "Les agents Forge générés avec le code n'utilisent pas de sources de connaissances classiques",
  'rovo-chat.view-agent.inactive-action-tooltip': 'Inactif',
  'rovo-chat.view-agent.instructions-label': 'Instructions',
  'rovo-chat.view-agent.knowledge-label': 'Connaissances',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} membre} other {{count,number} membres}}',
  'rovo-chat.view-agent.modal-title': 'Parcourir les agents',
  'rovo-chat.view-agent.no-actions': 'Aucune action',
  'rovo-chat.view-agent.no-behaviour-placeholder': "Cet agent n'a pas de comportements personnalisés",
  'rovo-chat.view-agent.no-instruction-placeholder': "Cet agent n'a pas d'instructions personnalisées",
  'rovo-chat.view-agent.no-knowledge-added': 'Aucune connaissance organisationnelle',
  'rovo-chat.view-agent.no-scenarios': 'Aucun scénario',
  'rovo-chat.view-agent.no-skills': 'Aucune compétence',
  'rovo-chat.view-agent.no-teams': "Ne fait partie d'aucune équipe",
  'rovo-chat.view-agent.open-chat-label': 'Discussion ouverte',
  'rovo-chat.view-agent.reactions-metadata-label': 'Nombre de réactions',
  'rovo-chat.view-agent.rovo-agent-label': 'Agent Rovo',
  'rovo-chat.view-agent.scenarios-label': 'Scénarios',
  'rovo-chat.view-agent.skills-label': 'Compétences',
  'rovo-chat.view-agent.teams-label': 'Équipes',
  'rovo-chat.view-agent.users-metadata-label': "Nombre d'utilisateurs",
  'rovo.agent.scenarios.scenarioModal.actionsLabel': 'Actions',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': 'Instructions',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': 'Connaissances',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'Serveurs MCP',
  'rovo.agent.scenarios.scenarioModal.noActions': 'Aucune action',
  'rovo.agent.scenarios.scenarioModal.noInstructions': 'Aucune instruction',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': 'Aucun serveur MCP',
  'rovo.agent.scenarios.scenarioModal.noSkills': 'Aucune compétence',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': 'Compétences',
  'rovo.conversation.assistant.agent.deepResearchPill': 'Recherche approfondie',
};
